import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnumValueDto, FacilityTypeDto, StateDto } from '../models';

export interface PermissionTypeDto {
  id: number;
  permissionName: string;
  permissionDescription?: string;
  category: string;
  isActive: boolean;
}

export interface FacilitySubtypeDto {
  id: number;
  name: string;
  description: string | null;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private readonly baseUrl = '/api/lookups';

  constructor(private http: HttpClient) {}

  /**
   * Get all permission types
   * @returns Observable array of PermissionTypeDto
   */
  getPermissionTypes(): Observable<PermissionTypeDto[]> {
    return this.http.get<PermissionTypeDto[]>(
      `${this.baseUrl}/permission-types`
    );
  }

  /**
   * Get all active facility subtypes (departments)
   * @returns Observable array of FacilitySubtypeDto
   */
  getFacilitySubtypes(): Observable<FacilitySubtypeDto[]> {
    return this.http.get<FacilitySubtypeDto[]>(
      `${this.baseUrl}/facility-subtypes`
    );
  }

  getFacilityTypes(): Observable<FacilityTypeDto[]> {
    return this.http.get<FacilityTypeDto[]>(`${this.baseUrl}/facility-types`);
  }

  getStates(): Observable<StateDto[]> {
    return this.http.get<StateDto[]>(`${this.baseUrl}/states`);
  }

  getFacilityStatuses(): Observable<EnumValueDto[]> {
    return this.http.get<EnumValueDto[]>(`${this.baseUrl}/facility-statuses`);
  }
}
